import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, MessageCircle, Search, User } from "lucide-react";
import { useApp } from "@/contexts/AppContext";

const tabs = [
  { icon: Home, label: "Home", path: "/" },
  { icon: Search, label: "Search", path: "/search" },
  { icon: MessageCircle, label: "Chat", path: "/messages" },
  { icon: User, label: "Profile", path: "/settings" },
];

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { conversations, friendRequests } = useApp();

  const totalUnread = conversations.reduce((sum, c) => sum + c.unread, 0) + friendRequests.length;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      <div className="bg-card/80 backdrop-blur-2xl border-t border-border/30 px-2 pb-1 pt-1.5 flex items-center justify-around max-w-lg mx-auto">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path || (tab.path === "/" && location.pathname === "/index");
          return (
            <motion.button
              key={tab.path}
              whileTap={{ scale: 0.85 }}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center py-1.5 px-5 relative"
            >
              {isActive && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute -top-1.5 w-6 h-0.5 rounded-full gradient-premium"
                  transition={{ type: "spring", stiffness: 500, damping: 30 }}
                />
              )}
              <div className="relative">
                <tab.icon className={`w-5 h-5 transition-colors duration-200 ${isActive ? "text-foreground" : "text-muted-foreground/60"}`} />
                {tab.label === "Chat" && totalUnread > 0 && (
                  <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-destructive text-[8px] font-bold text-destructive-foreground flex items-center justify-center shadow-[0_0_6px_hsl(var(--destructive)/0.6)]">
                    {totalUnread > 9 ? "9+" : totalUnread}
                  </span>
                )}
              </div>
              <span className={`text-[9px] mt-0.5 font-medium transition-colors duration-200 ${isActive ? "text-foreground" : "text-muted-foreground/50"}`}>
                {tab.label}
              </span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
